module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-builder-editor-field', _vm._g({
    attrs: {
      "item": _vm.item,
      "show-hide-in-form": true,
      "show-hide-in-preview": true,
      "show-hide-in-reports": true,
      "show-required": true,
      "show-share-with-participant": true,
      "show-is-shared": true
    }
  }, _vm.$listeners), [(_vm.item.type === 'rating') ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.item.name + '-label-low'
    }
  }, [_vm._v("Lowest Rating Text")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.minText),
      expression: "item.minText"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.item.name + '-label-low',
      "type": "text",
      "min": "1",
      "max": "19"
    },
    domProps: {
      "value": (_vm.item.minText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "minText", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": _vm.item.name + '-label-high'
    }
  }, [_vm._v("Highest Rating Text")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.maxText),
      expression: "item.maxText"
    }],
    staticClass: "form-control",
    attrs: {
      "id": _vm.item.name + '-label-high',
      "type": "text",
      "min": "1",
      "max": "19"
    },
    domProps: {
      "value": (_vm.item.maxText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "maxText", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('editor-options-list', {
    attrs: {
      "values": _vm.item.values,
      "id": _vm.item.name,
      "edit-value": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f569461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/editors/FormBuilderEditorRating.vue
// module id = 1663
// module chunks = 1